import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRevoke = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Group_7521",
	"data-name": "Group 7521",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 20,
	height: 16.364,
	viewBox: "0 0 20 16.364",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_3884",
				"data-name": "Rectangle 3884",
				width: 20,
				height: 16.364
			})
		}) }),
		/* @__PURE__ */ _jsx("g", {
			id: "Group_7519",
			"data-name": "Group 7519",
			clipPath: "url(#clip-path)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_19312",
				"data-name": "Path 19312",
				d: "M18.182,0H1.818A1.812,1.812,0,0,0,0,1.818V12.727a1.818,1.818,0,0,0,1.818,1.818H6.364v1.818h7.273V14.545h4.545a1.816,1.816,0,0,0,1.809-1.818L20,1.818A1.818,1.818,0,0,0,18.182,0m0,12.727H1.818V1.818H18.182ZM13.636,8.182H6.364V6.364h7.273Z"
			})
		})
	]
});
const ForwardRef = forwardRef(SvgRevoke);
export default ForwardRef;
